import React, { useState } from 'react'

import appConfig from '@src/appConfig.json'

import useDocumentTitle from '@hooks/useDocumentTitle'
import { useLoader } from '@hooks/useLoader'

import { loadTemplate } from '@helpers/loadTemplate'

function TosProvider() {
  useDocumentTitle(appConfig.pageTitle.provider)

  const [text, setText] = useState(null)

  const rules = []

  const isLoading = useLoader(async () => {
    const data = await loadTemplate('provider')
    if (data) {
      setText(data)
    }
  })

  return (
    !isLoading &&
    text.map((x) =>
      window.ziphyTosRenderJSON({
        json: x,
        rules,
        createElement: React.createElement,
        disabledRules: ['hidden'],
      }),
    )
  )
}

export default TosProvider
